import { createContext, useContext } from "react";

export const UnitContext = createContext();

function UnitProvider(props) {
	return <UnitContext.Provider {...props} />;
}

function useUnitContext() {
	return useContext(UnitContext);
}

export { UnitProvider, useUnitContext };
